import Meta from "./Meta.jsx";

export default Meta;